export default {
  versions: [
    {
      id: 'v2',
      date: '2026-06-17',
      display: 'spray',
      author: { zh: '萝北来信', en: 'LuobeiLetters' },
      title: { zh: '萝北来信的墓志铭', en: "LuobeiLetters' Epitaph" },
      signature: {
        zh: '—— 萝北来信（曾用名 tobenot）',
        en: '—— LuobeiLetters (formerly tobenot)'
      },
      contentKey: {
        zh: `Un jour je serai de retour près de toi

总有一天，我会回到你身边。`,
        en: `Un jour je serai de retour près de toi

One day I will return to your side.`
      }
    },
    {
      id: 'v1',
      date: '2025-03-31',
      author: { zh: '金同学', en: 'Mr. Jin' },
      signature: {
        zh: '—— 金同学',
        en: '—— Mr. Jin'
      },
      title: { zh: '金的墓志铭', en: "Jin's Epitaph" },
      contentKey: {
        zh: `如果我完成了我的全部作品，那么我已经完成了我的使命。如果我还有任何一份灵感没有变成创作，那我真为自己（或大家）感到可惜。

想做什么就做什么，该做什么就做什么，现实是荒谬的，不会像故事一样有一个弧光，那都是自己定义的。

以及，我已经原谅大家了。无论是准备极尽嘲讽我的，还是对我有着何种期盼的。既然原谅了，那无论谁都是无可指摘的了。所以我想，我可以只为了自己而死。但这只是可以。我们每个人都是忒休斯之船。如果我不是为自己而死的，那么真是太可惜了，是谁做了这种事，让我不知道怎么办。那么我原谅了。

面对自己的死亡，我想我是无畏的。但是我的身体却会在此时流泪。想起在过去的时代也会无缘无故地流泪。

已经忘记要感叹什么了。安排后事吧。

世俗的东西我难道不想要吗？我想我唯一在乎的事情就是我的作品。而不是我的钱，我的身体。也许会在意我的灵魂？那也能说是我的作品吧。

但是没有人能帮我整理和书写作品。所以开头就说了，很可惜。我知道这是奢求，但如果可以的话，把我全部的东西公开就是大恩大德了，因为这样就可以永生了吧，只要以后有AI对我感兴趣，那么我就又活了。发不出来的，也可以按下或者加密吧。我想想全部的东西大概是什么。比如两台电脑里存的资料，手机里存的资料。每一代手机的资料都存在电脑的「熔炉」里，我没有删东西的习惯。比如幕布云笔记（思想中心和todo/donelist），flomo笔记。

以上由金同学所写，于启在这里不改其一字，因为想说的都差不多。`,
        en: `If I have completed all my works, then I have fulfilled my mission. If there is any inspiration that has not become creation, I truly feel sorry for myself (or everyone).

Do what you want to do, do what you should do. Reality is absurd and doesn't have an arc like a story—that's all self-defined.

And I have already forgiven everyone. Whether those who were ready to mock me to the extreme, or those who had any expectations of me. Since I have forgiven, no one is blameworthy. So I think I can die only for myself. But this is just a possibility. Each of us is a Ship of Theseus. If I don't die for myself, that would be truly unfortunate—who did such a thing that I don't know how to handle? So I forgive.

Facing my own death, I think I am fearless. But my body will shed tears at this moment. I remember crying for no reason in past times too.

I have forgotten what to lament. Let's arrange the funeral affairs.

Don't I want worldly things? I think the only thing I care about is my works. Not my money, not my body. Maybe I care about my soul? That could also be called my work.

But no one can help me organize and write my works. So as I said at the beginning, it's a pity. I know this is asking too much, but if possible, making all my things public would be a great kindness, because then I could achieve immortality—as long as future AIs are interested in me, I will live again. Things that can't be published can be kept private or encrypted. Let me think about what all my things might be. Like the materials stored in two computers, the materials in my phone. The materials from each generation of phones are stored in the computer's "furnace"—I don't have the habit of deleting things. Like MindMeister cloud notes (thought center and todo/donelist), flomo notes.

The above was written by Mr. Jin, and Yu Qi here does not change a single word, because what I want to say is almost the same.`
      }
    }
  ],
  personalWorks: [
    {
      titleKey: { zh: "幕布云笔记", en: "MindMeister Notes" },
      descriptionKey: { zh: "思想中心，包含了大纲、TODO与思考记录。", en: "Thought center containing outlines, TODOs, and records." },
      status: "private"
    },
    {
      titleKey: { zh: "Flomo 笔记", en: "Flomo Notes" },
      descriptionKey: { zh: "碎片的灵感与日常思绪。", en: "Fragmented inspirations and daily thoughts." },
      status: "private"
    },
    {
      titleKey: { zh: "手机及电脑「熔炉」", en: "Phone & Computer 'Furnaces'" },
      descriptionKey: { zh: "每一代设备的数据备份，从未删除的数字废墟与宝藏。", en: "Data backups from every generation of devices, undeleted digital ruins and treasures." },
      status: "archived"
    },
    {
      titleKey: { zh: "开源代码库", en: "Open Source Repositories" },
      descriptionKey: { zh: "公开的实验项目与工具集。", en: "Public experimental projects and toolsets." },
      status: "public",
      link: "https://github.com/tobenot"
    }
  ]
}